import { useState } from "react";
import { Plus, Search, Trash2, Users } from "lucide-react";
import { api, money } from "@/util";

export default function Customers({ customers, user, onNew, onChanged }) {
  const [query, setQuery] = useState("");
  const isManager = user?.role === "Yönetici";

  const filtered = customers.filter((c) =>
    `${c.name} ${c.phone} ${c.email} ${c.tour}`.toLocaleLowerCase("tr-TR").includes(query.toLocaleLowerCase("tr-TR"))
  );

  const remove = async (id) => {
    if (!isManager) return;
    if (!window.confirm("Bu müşteri silinsin mi?")) return;
    await api.delete(`/customers/${id}`);
    onChanged?.();
  };

  return (
    <section className="page-section">
      <div className="section-header">
        <div>
          <span className="eyebrow">CARİ HESAPLAR</span>
          <h2>Müşteriler & satışlar</h2>
          <p>Müşterilerinin iletişim bilgilerini ve bakiyelerini tek yerden izle.</p>
        </div>
        <button className="primary-button" onClick={() => onNew("customer")} data-testid="customers-add-button">
          <Plus size={17} /> Yeni müşteri
        </button>
      </div>
      <div className="filter-row">
        <div className="search">
          <Search size={16} />
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Ad, telefon, tur..." data-testid="customer-search-input" />
        </div>
      </div>
      {filtered.length ? (
        <div className="table-wrap">
          <table className="data-table" data-testid="customers-table">
            <thead>
              <tr>
                <th>Ad</th>
                <th>İletişim</th>
                <th>Kayıtlı tur</th>
                <th className="right">Bakiye</th>
                <th>Not</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {filtered.map((c, idx) => (
                <tr key={c.id} data-testid={`customer-row-${idx}`}>
                  <td>
                    <b>{c.name}</b>
                    {c.identity_no && <small> · {c.identity_no}</small>}
                  </td>
                  <td>
                    <span>{c.phone || "—"}</span>
                    <small className="muted">{c.email}</small>
                  </td>
                  <td>{c.tour || <span className="muted">—</span>}</td>
                  <td className={`right ${c.balance > 0 ? "negative" : "positive"}`}>
                    <b>{money(c.balance)}</b>
                  </td>
                  <td className="muted">{c.notes || "—"}</td>
                  <td>
                    {isManager && (
                      <button className="icon-button small danger" onClick={() => remove(c.id)} data-testid={`customer-delete-${idx}`} title="Sil">
                        <Trash2 size={14} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-page">
          <div className="empty-icon"><Users size={24} /></div>
          <h2>Henüz müşteri yok</h2>
          <p>Üstteki "Yeni müşteri" düğmesinden ilk cari hesabını ekleyebilirsin.</p>
        </div>
      )}
    </section>
  );
}
